var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "horizontalChoice", attrs: { id: "colissimoContainer" } },
    _vm._l(_vm.colissimoPoints, function(point) {
      return _c("label", { staticClass: "custom-control custom-radio" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selectedModel,
              expression: "selectedModel"
            }
          ],
          staticClass: "custom-control-input input",
          attrs: {
            id: "input-" + point.identifiant,
            type: "radio",
            name: "colissimo[point]"
          },
          domProps: {
            value: point.identifiant,
            checked: _vm._q(_vm.selectedModel, point.identifiant)
          },
          on: {
            change: function($event) {
              _vm.selectedModel = point.identifiant
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "custom-control-label",
            attrs: { for: "input-" + point.identifiant }
          },
          [
            _c("span", { staticClass: "description-colissimo" }, [
              _c("strong", [_vm._v(_vm._s(point.nom))]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(point.adresse1))]),
              _vm._v(" "),
              point.address2
                ? _c("span", [_vm._v(_vm._s(point.adresse2))])
                : _vm._e(),
              _vm._v(" "),
              point.address3
                ? _c("span", [_vm._v(_vm._s(point.adresse3))])
                : _vm._e(),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(point.codePostal) +
                    " " +
                    _vm._s(point.localite) +
                    " " +
                    _vm._s(point.libellePays)
                )
              ])
            ])
          ]
        )
      ])
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-389bfd7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-389bfd7e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/Order/OrderInputColissimo.vue
// module id = 392
// module chunks = 0 1